import { useEffect, useState } from 'react'
import { Search } from 'lucide-react'
import { useNavigate, useSearchParams } from 'react-router-dom'

function SearchBar({ placeholder = 'Que aula você quer encontrar?', initialValue = '', preserveParams = false }) {
  const [query, setQuery] = useState(initialValue)
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    setQuery(initialValue)
  }, [initialValue])

  const handleSubmit = (e) => {
    e.preventDefault()
    if (query.trim()) {
      const nextParams = preserveParams ? new URLSearchParams(searchParams) : new URLSearchParams()
      nextParams.set('q', query.trim())
      navigate(`/explorar?${nextParams.toString()}`)
    }
  }

  return (
    <form onSubmit={handleSubmit} className="relative">
      <div className="flex items-center gap-2 px-3 py-2.5 border border-gray-200 rounded-xl bg-white focus-within:border-black focus-within:ring-1 focus-within:ring-black transition-all">
        <Search size={18} className="text-gray-400 flex-shrink-0" />
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={placeholder}
          className="flex-1 bg-transparent outline-none text-sm placeholder:text-gray-400"
        />
        <button type="submit" className="text-xs font-medium px-2 py-1 rounded-lg hover:bg-gray-100 dark:hover:bg-zinc-800">
          Explorar
        </button>
      </div>
    </form>
  )
}

export default SearchBar
